const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');
const { toMinorUnit } = require('@/functions/math');

class DojoAbstractTransactionCreateRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {} payload
     * @param {String} transactionType
     */
    constructor(config, payload, transactionType) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }
        if (payload && !payload.amount) {
            throw new Error('amount is required');
        }
        if (!transactionType) {
            throw new Error('transactionType is required');
        }

        const url = 'pac/terminals/' + config.terminalId + '/transactions';

        let data = {
            currency: config.currency,
            transactionType,
            // The api always expects a positive integer.
            amount: Math.abs(toMinorUnit(payload.amount)),
        };

        if (payload.amountCashback) {
            const amountCashback = Math.abs(toMinorUnit((payload.amountCashback)));
            if (amountCashback > 0) {
                data.amountCashback = amountCashback;
            }
        }

        if (payload.cardholderNotPresent) {
            data.cardholderNotPresent = true;
        }

        super(
            'POST',
            url
        );
        this.data = data;
    }
}

module.exports = DojoAbstractTransactionCreateRequestRecord;
